import type { MenuConfig } from '~typings/menu'

import permisosCxP, { RESOURCE_CXP } from '@/auth/permissions/modules/cxp'
import * as names from '@routes/cxp/nombres/informes'

const { informes } = permisosCxP
export default [
    {
        title: 'cuentas_x_pagar.subopciones.saldo_anticipos',
        route: names.ROUTE_INFORME_SALDOS_ANTICIPO,
        resource: RESOURCE_CXP,
        action: informes.saldoAnticipos,
    },
    {
        title: 'cuentas_x_pagar.subopciones.proveedores_corte',
        route: names.ROUTE_INFORME_PROVEEDORES_CORTE,
        resource: RESOURCE_CXP,
        action: informes.proveedoresCorte,
    },
    {
        title: 'cuentas_x_pagar.subopciones.obligaciones_vencer_vencida',
        route: names.ROUTE_INFORME_OBLIGACIONES_VENCER_VENCIDAS,
        resource: RESOURCE_CXP,
        action: informes.obligacionesVencerVencidas,
    },
    {
        title: 'cuentas_x_pagar.subopciones.cartera306090',
        route: names.ROUTE_INFORME_CARTERA_30_60_90,
        resource: RESOURCE_CXP,
        action: informes.cartera306090,
    },
    {
        title: 'cuentas_x_pagar.subopciones.estado_cuenta',
        route: names.ROUTE_INFORME_ESTADO_CUENTA,
        resource: RESOURCE_CXP,
        action: informes.estadoCuenta,
    },
    {
        title: 'cuentas_x_pagar.subopciones.flujo_pago_proveedor',
        route: names.ROUTE_INFORME_FLUJO_PAGO_PROVEEDOR,
        resource: RESOURCE_CXP,
        action: informes.flujoPagoProveedor,
    },
] as MenuConfig[]
